import React, {
  Component,
  Fragment,
  useState,
  useLayoutEffect,
  useEffect,
  useRef,
} from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  getCardSkills,
  excecuteCardSkill,
  updateCardSkills,
  deleteCardSkill,
  saveCardSkills,
} from '../skill_builder/steps/CardActions';
import SelectCard from '../skill_builder/steps/cardInvocationDetails/SelectCard';
import { getCardTemplates } from '../skill_builder/steps/CardActions';
import EditSkill from '../EditSkill';
import { addActivityLog } from '../../common/activityLog';
import SkillConnectModal from './connectionModal';
import queryString from 'query-string';
import axios from 'axios';
import CreationPage from './reportCreationPage';
// import jwt from 'jsonwebtoken';
//  let  res=await this.props.getCurrentSkill(this.props.match.params.wId,query)
import {
  getChannelList,
  getCurrentSkill,
  getSkillUser,
  searchWorkspaceMembers,
} from '../skills_action';

import {
  handleSelectedProject,
  setTemplate,
  handleEditMode,
  handleTemplateFormat,
  card_template_id,
  resetStore,
} from './report_actions';
import {
  CloseOutlined,
  GithubOutlined,
  SearchOutlined,
  DownOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import './cardSkill.css';
import Highlighter from 'react-highlight-words';
import {
  Button,
  Table,
  Divider,
  Card,
  Menu,
  Dropdown,
  Row,
  Col,
  message,
  notification,
  Tag,
  Avatar,
  Layout,
  Radio,
  Icon,
  Input,
  PageHeader,
  Tooltip,
  Tabs,
  Popconfirm,
} from 'antd';

import { cardInfo } from './report_actions';
import { newTemplateData, templateData } from './templateData';
import { isValidUser } from '../../../utils/utils';
import ReportLandingPage from './report_landing_page';
const { Meta } = Card;
const { CheckableTag } = Tag;
const { Content } = Layout;
const { TabPane } = Tabs;
const tagsFromServer = ['Jira', 'GitHub'];

const CardSkillList = (props) => {
  const templateCards = useSelector((state) => state.cards.templateCards);

  useEffect(() => {
    if (!templateCards.length)
      dispatch(getCardTemplates(props.match.params.wId, `app=Jira`));
  }, []);
  const filteredSkills = templateCards.filter((i) => !i.isHidden);
  // console.log(getReleventReports(cardSkillWithuser));

  const jiraSkill = props.skills.find((skill) => skill.key === 'jira');

  let searchInput = useRef();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [channelsLoading, setChannelsLoading] = useState(false);
  const [isReportLandingPage, setIsReportLandingPage] = useState(false);
  const [cardSkillWithuser, setCardSkillWithuser] = useState();
  const [warning, setWarning] = useState({});
  const [reportScope, setReportScope] = useState('');

  const [isCreate, setIsCreate] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [selectedCardSkill, setSelectedCardSkill] = useState(null);

  const [showListReportPage, setShowListReportPage] = useState(false);
  const [showChartReportPage, setShowChartReportPage] = useState(false);
  const [ShowCreationPage, setShowCreationPage] = useState(false);
  const [chartType, setChartType] = useState('');
  const [currentTab, setCurrentTab] = useState('my_reports');

  const [isEditMode, setIsEditMode] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState();
  const [membersList, setMembersList] = useState([]);
  const [selectedReportId, setSelectedReportId] = useState(null);

  // console.log(props);
  let skill = {};
  // console.log(props);
  useEffect(() => {
    // this.setState({ loading: true })
    setLoading(true);
    const parsedQueryString = queryString.parse(props.location.search);
    // console.log(parsedQueryString);
    if (
      (props.channels && props.channels.length === 0) ||
      (parsedQueryString.from &&
        parsedQueryString.from === 'jira_conection_onboarding')
    ) {
      // this.setState({ channelsLoading: true });
      setChannelsLoading(true);
      props
        .getChannelList(props.match.params.wId)
        .then((res) => setChannelsLoading(false));
    }
    let query = '';

    if (props.skill) {
      query = 'app=' + props.skill.name;
      props.getCardTemplates(props.match.params.wId, query);

      skill = props
        .getCardSkills(props.workspace_id, 'app_message', props.skill.name)
        .then((res) => {
          // console.log('oaasj', res.data.cardSkills);
          if (res.data.success) {
            setUserNameInCardSkills(res.data.CardSkills);
            // this.setState({ loading: false });
            setLoading(false);
          }
        });
    } else {
      skill = props.getCardSkills(props.workspace_id, 'app_message');
    }
    // })

    if (props.skillView && props.skillView.report_id) {
      setIsReportLandingPage(true);
      setReportScope(true);
    }

    let isCreate_ = props.location.search.split('=')[2] === 'true';
    if (isCreate_) {
      // this.setState({ isCreate: true });
      setIsCreate(true);
    }
  }, []);

  useEffect(() => {
    if (!membersList.length) {
      dispatch(
        searchWorkspaceMembers(props.match.params.wId, '', props.type)
      ).then((data) => {
        if (data.data && data.data.members) {
          setMembersList(data.data.members);
        }
      });
    }
  }, [membersList]);

  useEffect(() => {
    if (props && props.cardSkills) setUserNameInCardSkills(props.cardSkills);
    setLoading(false);
  }, [props.cardSkills]);

  const setUserNameInCardSkills = (CardSkills) => {
    // console.log('ankit props', props);
    let cardSkillWithuser = [];
    CardSkills.forEach((report) => {
      // console.log(this.props.allUsers);
      const userFound = report.user_id;

      if (userFound.email) {
        // report.user_id = userFound
        report.creator_name =
          userFound.displayName ||
          userFound.name ||
          userFound.user_name ||
          userFound.email;
      } else {
        report.creator_name = 'Not a member';
      }

      //for channel search
      // let channelPresent = report.slackData && this.props.channels.find(c => c.id ===  report.slackData.slackChannel);
      let channelPresent = [];
      let isChannelPresent =
        report.slackData &&
        report.slackData.slackChannel &&
        report.slackData.slackChannel;
      if (Array.isArray(isChannelPresent)) {
        let channelDetails;
        isChannelPresent.forEach((channel) => {
          channelDetails = false;
          channelDetails = props.channels.find((c) => c.id === channel);
          if (channelDetails) {
            channelPresent.push(channelDetails);
          }
        });
      } else {
        channelPresent = props.channels.find((c) => c.id === isChannelPresent);
      }

      if (channelPresent) {
        report.channel_name = channelPresent;
      } else {
        report.channel_name = '';
      }
      cardSkillWithuser.push(report);
    });

    // this.setState({ cardSkillWithuser });
    setCardSkillWithuser(cardSkillWithuser);
  };

  const getReleventReports = (reports) => {
    const { user_now } = props;
    if (currentTab === 'all_reports') return reports;
    else {
      return (
        reports &&
        reports.filter((report) => {
          const userIdMatches =
            typeof report.user_id === 'object' && report.user_id !== null
              ? report.user_id.user_id === user_now._id
              : report.user_id === user_now._id;

          const accessMemberMatches =
            report.reportAccessMembers &&
            report.reportAccessMembers.some((member) => {
              return member && member.user_id === user_now._id;
            });

          return userIdMatches || accessMemberMatches;
        })
      );
    }
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            searchInput = node;
          }}
          placeholder={`Search`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type='primary'
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size='small'
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters)}
          size='small'
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => <SearchOutlined />,
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select());
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          textToHighlight={text.toString()}
          autoEscape
        />
      ) : (
        text
      ),
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();

    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const gotoReportLandingPage = (id) => {
    props.history.push(
      `/${props.match.params.wId}/skills/${props.match.params.skill_id}/${props.match.params.sub_skill}?view=reports&report_id=${id}`
    );
    // this.setState({ isReportLandingPage: true });
    setIsReportLandingPage(true);
  };

  const getDeliverChannelAndMember = (slackData) => {
    let notExistChannels = [];
    let existChannels = [];
    let existMemberDetails = [];
    let notExistMembersDetails = [];

    if (slackData) {
      if (slackData.slackChannel && Array.isArray(slackData.slackChannel)) {
        let channelDetails = '';
        slackData.slackChannel.map((schannel) => {
          channelDetails = props.channels.find(
            (channel) => channel.id === schannel
          );
          if (channelDetails) {
            existChannels.push({
              id: channelDetails.id,
              name: channelDetails.name,
              type: 'channel',
            });
          } else {
            notExistChannels.push(schannel);
          }
        });
      } else {
        let singleChannelDetails = props.channels.find(
          (c) => c.id === slackData.slackChannel
        );
        if (singleChannelDetails) {
          existChannels.push({
            id: singleChannelDetails.id,
            name: singleChannelDetails.name,
            type: 'channel',
          });
        } else {
          notExistChannels = slackData.slackChannel;
        }
      }

      if (
        slackData &&
        slackData.reportMembers &&
        Array.isArray(slackData.reportMembers)
      ) {
        slackData.reportMembers.map((member) => {
          let userDetails = member;
          if (userDetails && userDetails.email) {
            existMemberDetails.push({
              id: userDetails.user_id,
              name:
                userDetails.displayName ||
                userDetails.name ||
                userDetails.user_name ||
                userDetails.email,
              type: 'user',
            });
          } else {
            const userDetails =
              membersList &&
              membersList.length &&
              membersList.find(
                (memb) =>
                  memb.user_id === member ||
                  memb.slackInfo.user_name === member ||
                  memb.slackInfo.displayName === member
              );
            if (userDetails) {
              notExistMembersDetails.push({
                id: userDetails.user_id,
                name:
                  userDetails.slackInfo.displayName ||
                  userDetails.slackInfo.name ||
                  userDetails.slackInfo.user_name ||
                  userDetails.email,
                type: 'user',
              });
            }
          }
        });
      }
    }

    let deliverDetails = [
      ...existChannels,
      ...existMemberDetails,
      ...notExistMembersDetails,
    ];

    return deliverDetails;
  };

  const validateChannels = (channels, selectedChannels) => {
    let notExistChannels = [];
    if (selectedChannels) {
      if (Array.isArray(selectedChannels)) {
        selectedChannels.map((schannel) => {
          if (channels.some((channel) => channel.id === schannel)) {
          } else {
            notExistChannels.push(schannel);
          }
        });
      } else {
        if (channels.find((c) => c.id === selectedChannels)) {
        } else {
          notExistChannels = selectedChannels;
        }
      }
    }
    return notExistChannels;
  };

  const skillTokenValidation = async (template) => {
    // return new Promise(async(resolve,rej)=>{
    if (template.app === 'Jira' || template.app === 'GitHub') {
      let skill = {};
      let currentSkillUser = {};

      if (props.skill) {
        skill = props.skill;
        // this.props.currentSkill.skill_metadata
      } else {
        let query = 'name=' + template.app;
        let res = await props.getCurrentSkill(props.match.params.wId, query);
        skill = res.data.skill;
      }

      if (
        props.currentSkillUser &&
        Object.keys(props.currentSkillUser).length == 0
      ) {
        currentSkillUser = await props.getSkillUser(
          props.match.params.wId,
          props.match.params.skill_id
        );
      } else {
        currentSkillUser = props.currentSkillUser;
      }
      // console.log('\n----- current skill user ', currentSkillUser, {
      //   ...props,
      // });
      // console.log('template===>', template);
      // console.log('skill====>', skill);
      if (
        skill &&
        ((skill.skill_metadata && skill.skill_metadata.linked) || skill.linked)
      ) {
        if (template.app === 'Jira') {
          if (template.meta && template.meta.isToken) {
            if (
              (skill.skill_metadata &&
                skill.skill_metadata.userName &&
                skill.skill_metadata.userToken) ||
              (skill.userName && skill.userToken) ||
              skill.metadata.domain_url
            ) {
              if (
                !(
                  currentSkillUser.token_obj &&
                  currentSkillUser.token_obj.access_token
                )
              ) {
                setWarning({
                  status: true,
                  skill: skill,
                  type: 'user_not_verified',
                });
                message.info('USER NOT VERIFIED ');
              } else {
                return 'create_modal';
              }
            } else {
              setWarning({
                status: true,
                skill: skill,
                type: 'jira_basic_token',
              });
              message.info('JIRA BASIC TOKEN ');
            }
          } else if (
            !(
              currentSkillUser.token_obj &&
              currentSkillUser.token_obj.access_token
            )
          ) {
            setWarning({
              status: true,
              skill: skill,
              type: 'user_not_verified',
            });
            message.info('USER NOT VERIFIED ');
          } else {
            return 'create_modal';
          }
        }
      } else {
        setWarning({ status: true, skill: skill, type: 'skill_not_connected' });
        message.info('Skill Not Connected');
      }
    } else {
      return 'create_modal';
    }

    // })
  };

  const showErrorMessage = () => {
    message.error(
      `You don't have permission to modify this skill. Only Creator or admin can modify it`
    );
  };

  const onSkillEdit = (skill) => {
    let isCreator = isValidUser(skill);
    if (isCreator || props.isAdmin) {
      // this.setState({ showEditModal: true, selectedTemplate: skill });
      setSelectedCardSkill(skill);

      setShowEditModal(true);
    } else {
      showErrorMessage();
    }
  };

  const execRunNow = async (skill) => {
    let isCreator = isValidUser(skill);
    //id=Zynga
    if (isCreator || props.isAdmin) {
      let modal = await skillTokenValidation(
        skill.cardInformation.card_template_id
      );
      if (modal === 'create_modal') {
        notification.success({
          key: 'runNowStatus',
          message: 'Request submitted',
          description:
            'If there is data to be sent, it will reach the configured Slack channel',
          placement: 'bottomLeft',
          duration: 3,
        });

        props.excecuteCardSkill(props.match.params.wId, skill._id);
      }
    } else {
      showErrorMessage();
    }
  };

  const toggleSkill = (record) => {
    let isCreator = isValidUser(record);
    isCreator || props.isAdmin
      ? props.updateCardSkills(props.match.params.wId, {
          _id: record._id,
          is_enabled: !record.is_enabled,
          EditOnly: true,
        })
      : showErrorMessage();
  };

  const showConfigModal = async (skill, e) => {
    e.preventDefault();
    // console.log('skill is here ', skill);
    let isCreator = isValidUser(skill);
    let skills = {};
    let query = '';

    if (isCreator || props.isAdmin) {
      let modal = await skillTokenValidation(
        skill.cardInformation.card_template_id
      );
      if (modal === 'create_modal') {
        if (props.skill) {
          query = 'app=' + props.skill.name;
          skills = props.getCardSkills(
            props.match.params.wId,
            'app_message',
            props.skill.name
          );
        } else {
          skills = props.getCardSkills(props.match.params.wId, 'app_message');
        }
        /* getChannels only called once in sidenavbar_new */
        // let channels = this.props.getChannelList(this.props.match.params.wId)
        Promise.all([skills /* , channels */]);

        // props.getCardTemplates(props.match.params.wId, query);
        // props.getAllUsers(props.match.params.wId);
        //>>>>>>>>>>>>>>>>>>>>>>>
        let isCreator = isValidUser(skill);
        // let isCreator = true
        if (
          isCreator ||
          props.match.params.wId == '5f84c0d0b038174751d7b805' ||
          props.isAdmin
        ) {
          let modal = await skillTokenValidation(
            skill.cardInformation.card_template_id
          );
          if (modal === 'create_modal') {
            dispatch(setTemplate(skill));
            dispatch(handleEditMode(true));
            let templateUsed = templateCards.find(
              (ct) => ct.key === skill.cardInformation.key
            );
            setSelectedTemplate(templateUsed);
            setSelectedCardSkill(skill);
            // setShowEditModal(true);
            dispatch(card_template_id(templateUsed));
            dispatch(cardInfo(skill.cardInformation.cardInformation));
            setIsEditMode(true);
            props.history.push(
              `/${props.match.params.wId}/skills/${props.match.params.skill_id}/${props.match.params.sub_skill}?view=reports&report_id=${skill._id}`
            );
            setShowCreationPage(true);
          }
        } else {
          showErrorMessage();
        }
      }
    } else {
      showErrorMessage();
    }
  };
  const main = useSelector((state) => state.report);
  // console.log('main', main)

  const goToReports = () => {
    props.history.push(
      `/${props.match.params.wId}/skills/${props.match.params.skill_id}/${props.match.params.sub_skill}?view=reports`
    );
    setIsReportLandingPage(false);
  };
  const onReportDelete = (report) => {
    // console.log("comming");
    let isCreator = isValidUser(report);
    if (isCreator || props.isAdmin) {
      props
        .deleteCardSkill(props.match.params.wId, report._id)
        .then((res) => {
          message.success('Report deleted');
          props.history.push(
            `/${props.match.params.wId}/skills/${props.match.params.skill_id}/${props.match.params.sub_skill}?view=reports`
          );
          setIsReportLandingPage(false);
        })
        .catch((e) => {
          // console.log(e);
          // console.error(e);
        });
    } else {
      showErrorMessage();
    }
  };

  const handleReportScopeChange = (val) => {
    setReportScope(val);
  };
  const table_columns = [
    {
      // className: 'response_column_without_table_top',
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      align: 'center',
      width: '200',
      // textWrap: 'ellipsis',
      //ellipsis:true,

      ...getColumnSearchProps('name'),

      // render: name => (
      //   <>
      //     <Button size="small" type="link" onClick={goToReport}>
      //       {name}
      //     </Button>
      //   </>
      // ),
      render: (text, data) => {
        return (
          <Tooltip placement='topLeft' title={text} trigger='hover'>
            <Button type='link' onClick={() => gotoReportLandingPage(data._id)}>
              <span
                style={{
                  maxWidth: 200,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {text}
              </span>
            </Button>{' '}
          </Tooltip>
        );
      },
    },
    {
      // className: 'response_column_without_table_top',
      title: 'Creator',
      dataIndex: 'creator_name',
      // key: "user_id",
      align: 'center',
      render: (text, record) => {
        // return <span>
        //   {this.props.allUsers && this.props.allUsers.map(user => {
        //     if (text === user.user_id) {
        //       return user.name
        //     } else {
        //       return false
        //     }
        //   })}
        // </span>
        // const userFound = this.props.allUsers.find(user => user.user_id === text)
        // if(userFound) return userFound.name
        // else return 'Not a member'
        // render: (text, data) => "heeloworld",
        return <span>{text}</span>;
      },
      ...getColumnSearchProps('creator_name'),
    },
    {
      title: 'Status',
      key: 'is_enabled',
      align: 'center',
      dataIndex: 'is_enabled',
      maxWidth: 100,
      width: 100,
      sorter: (a, b) =>
        (a.is_enabled ? 'Enabled' : 'Not Enabled').length -
        (b.is_enabled ? 'Enabled' : 'Not Enabled').length,
      sortDirections: ['descend', 'ascend'],
      render: (text, record) => {
        if (record.is_enabled) {
          return <Tag color='green'>Enabled</Tag>;
        } else {
          return <Tag color='orange'>Not Enabled</Tag>;
        }
      },
    },
    {
      title: 'Schedule',
      key: 'frequency',
      align: 'center',
      dataIndex: 'triggerInformation',

      render: (text, record) => {
        return text ? (
          <div>
            {text.frequency === 'daily' ? 'Daily' : 'Every ' + text.selectedDay}{' '}
            at {text.timeOfDay}{' '}
          </div>
        ) : (
          ''
        );
      },
    },
    {
      // className: 'response_column_without_table_top',
      title: 'Delivery Channel',
      key: 'channel',
      align: 'center',
      dataIndex: 'channel_name',
      sorter: (a, b) => {
        if (a.channel_name < b.channel_name) {
          return -1;
        }
        if (a.channel_name > b.channel_name) {
          return 1;
        }
        return 0;
      },
      sortDirections: ['descend', 'ascend'],
      // ...this.getColumnSearchProps("channel_name"),
      render: (text, record) => {
        let channelName = '';
        let deliverDetails = getDeliverChannelAndMember(record.slackData);
        let notExistChannels = validateChannels(
          props.channels,
          record.slackData && record.slackData.slackChannel
            ? record.slackData.slackChannel
            : []
        );
        let isPresent = notExistChannels.length > 0;

        // console.log(deliverDetails, notExistChannels);
        if (isPresent && record.slackData.slackChannel.length == 1) {
          return (
            <Tag color='orange'>{`Troopr was removed from channel ${notExistChannels}`}</Tag>
          );
        } else {
          // return <div>
          //   {this.props.channels.find(c => c.id === text.slackChannel) ? this.props.channels.find(c => c.id === text.slackChannel).name : ''}
          // </div>

          let reportDeliver = '';
          deliverDetails.map((deliver, index) => {
            if (index < 3) {
              reportDeliver += `${deliver.type === 'channel' ? '#' : ''}${
                deliver.name
              }${deliverDetails.slice(0, 3).length - 1 === index ? '' : ','} `;
            }
          });
          if (deliverDetails.length > 3) {
            reportDeliver += `and ${deliverDetails.length - 3} more`;
          }

          if (notExistChannels.length == 0) {
            return reportDeliver;
          } else {
            return (
              <div>
                {reportDeliver}
                <Tag color='orange'>{`Troopr was removed from channel ${notExistChannels}`}</Tag>
              </div>
            );
          }
        }
      },
    },
    {
      title: 'Actions',
      key: 'actions',
      align: 'center',
      width: 150,
      render: (text, record) => {
        let menu = (
          <Menu>
            <Menu.Item key='1'>
              <div
                onClick={() => onSkillEdit(record)}
                style={{ width: '100%' }}
              >
                Edit
              </div>
            </Menu.Item>
            <Menu.Item key='2'>
              <div style={{ width: '100%' }} onClick={() => execRunNow(record)}>
                Run Now
              </div>
            </Menu.Item>
            <Menu.Item key='3' onClick={() => toggleSkill(record)}>
              <div style={{ width: '100%' }}>
                {record.is_enabled ? 'Disable' : 'Enable'}
              </div>
            </Menu.Item>
            <Menu.Item key='3' onClick={() => setSelectedReportId(record._id)}>
              <div style={{ width: '100%' }}>Duplicate</div>
            </Menu.Item>
          </Menu>
        );
        return (
          <span>
            <a onClick={(e) => showConfigModal(record, e)}>Configure</a>
            <Divider type='vertical' />
            {selectedReportId === record._id ? (
              <Popconfirm
                visible={selectedReportId === record._id}
                placement='left'
                title='Are you sure to duplicate this report?'
                onConfirm={(e) => handleDuplicateReport(record, e)}
                onCancel={() => setSelectedReportId(null)}
                okText='Yes'
                cancelText='No'
              >
                <a>More</a>
              </Popconfirm>
            ) : (
              <Dropdown overlay={menu}>
                <a>More</a>
              </Dropdown>
            )}
          </span>
        );
      },
    },
  ];

  const showTemplates = () => {
    setIsCreate(true);
  };

  const hideTemplates = () => {
    setIsCreate(false);
  };

  const handleTabChange = (val) => {
    setCurrentTab(val);
  };
  const menu = (
    <Menu>
      <Menu.Item
        key='1'
        onClick={() => {
          setShowChartReportPage(true);
          setShowCreationPage(true);
          setChartType('chart');
          // if (!props.isEditMode) {
          let template =
            templateCards &&
            templateCards?.find((t) => t.key === 'custom_report_2');
          const defaultValues =
            (template && template.defaultValues) ||
            (newTemplateData &&
              newTemplateData.find((temp) => temp.key === 'custom_report_2')
                .defaultValues);
          dispatch(handleTemplateFormat(template));
          setSelectedTemplate(template);
          dispatch(cardInfo(defaultValues));

          // }
        }}
      >
        + Chart Report
      </Menu.Item>
      <Menu.Item
        key='2'
        onClick={() => {
          let template =
            templateCards &&
            templateCards.find((t) => t.name === 'Issues by Custom JQL');
          const defaultValues =
            (template && template.defaultValues) ||
            (newTemplateData &&
              newTemplateData.find(
                (temp) => temp.name == 'Issues by Custom JQL'
              ).defaultValues);
          setShowListReportPage(true);
          setShowCreationPage(true);
          setChartType('list');
          setSelectedTemplate(template);
          dispatch(handleTemplateFormat(template));
          dispatch(cardInfo(defaultValues));
        }}
      >
        + List Report
      </Menu.Item>
    </Menu>
  );

  const handleCreateClick = async (template) => {
    if (template.isUpcoming) {
      // console.log("clicked on gitlab");
      message.info('Coming Soon!');
      addActivityLog(
        props.workspace_id,
        `clicked on report ${template.name}`,
        'botui_cardskill_comingsoon',
        `clicked on report ${template.name}`
      );
      return;
    }

    let modal = await skillTokenValidation(template);
    // console.log('modal---->', modal);
    if (modal === 'create_modal') {
      setShowCreationPage(true);
      setChartType(template.key == 'get_issues_by_jql' ? 'list' : 'chart');
      setSelectedTemplate(template);
      dispatch(handleTemplateFormat(template));
      dispatch(cardInfo(template.defaultValues));
    }
  };

  const handleShowCreationPage = (val) => {
    setShowCreationPage(val);
    if (val == false) {
      setSelectedCardSkill(null);
      setSelectedTemplate(null);
    }
  };

  const handleDuplicateReport = (report, e) => {
    setSelectedReportId(false);
    const data = {
      cardInformation: {
        cardInformation: report.cardInformation.cardInformation,
        card_template_id: report.cardInformation.card_template_id._id,
        key: report.cardInformation.key,
        issueCardCustomizationInfo:
          report.cardInformation.issueCardCustomizationInfo,
      },
      slackData: report.slackData,
      triggerInformation: report.triggerInformation,
      workspace_id: report.workspace_id,
      app: report.app,
      name: report.name,
      desc: report.desc,
      skill_type: report.skill_type,
    };

    props.saveCardSkills(props.match.params.wId, data).then((res) => {
      if (res.data.success) {
        message.success('Copy of your report has been created successfully');
        showConfigModal(res.data.cardSkill, e);
      }
    });
  };

  return (
    <Layout>
      {ShowCreationPage ? (
        <CreationPage
          setShowCreationPage={handleShowCreationPage}
          cardSkill={selectedCardSkill}
          template={selectedTemplate}
          setCurrent={(val) => setCurrentTab(val)}
          isEditMode={isEditMode}
          chartType={chartType}
          skill_type='app_message'
          setIsEditMode={(data) => setIsEditMode(data)}
          skillView={props.skillView}
          membersList={membersList}
        />
      ) : isReportLandingPage ? (
        <ReportLandingPage
          skillView={props.skillView}
          goToReports={goToReports}
          showConfigModal={showConfigModal}
          toggleSkill={toggleSkill}
          execRunNow={execRunNow}
          onReportDelete={onReportDelete}
          membersList={membersList}
        />
      ) : (
        <>
          {!isReportLandingPage && (
            <PageHeader
              title='Channel Reports'
              extra={
                isCreate
                  ? [
                      <Button
                        type='primary'
                        icon={isCreate && <CloseOutlined />}
                        onClick={() => {
                          return isCreate ? hideTemplates() : showTemplates();
                        }}
                      >
                        {isCreate ? 'Cancel' : 'Add Report'}
                      </Button>,
                      <Button
                        onClick={() => {
                          if (
                            !(
                              props.currentSkillUser &&
                              props.currentSkillUser.token_obj &&
                              props.currentSkillUser.token_obj.access_token
                            )
                          ) {
                            setWarning({
                              status: true,
                              skill: props.skill,
                              type: 'user_not_verified',
                            });
                          } else {
                            props.history.push(
                              `/${props.match.params.wId}/jiraConnectionSteps/${jiraSkill.skill_metadata._id}?domainName=${jiraSkill.skill_metadata.metadata.domain_url}&sub_skill=${props.match.params.sub_skill}&from=setup_demo_channel_button`
                            );
                          }
                        }}
                      >
                        Setup Demo Report
                      </Button>,
                    ]
                  : [
                      <Button
                        onClick={() => {
                          if (
                            !(
                              props.currentSkillUser &&
                              props.currentSkillUser.token_obj &&
                              props.currentSkillUser.token_obj.access_token
                            )
                          ) {
                            setWarning({
                              status: true,
                              skill: props.skill,
                              type: 'user_not_verified',
                            });
                          } else {
                            props.history.push(
                              `/${props.match.params.wId}/jiraConnectionSteps/${jiraSkill.skill_metadata._id}?domainName=${jiraSkill.skill_metadata.metadata.domain_url}&sub_skill=${props.match.params.sub_skill}&from=setup_demo_channel_button`
                            );
                          }
                        }}
                      >
                        Setup Demo Report
                      </Button>,
                      <Dropdown overlay={menu}>
                        <Button type='primary' icon={<PlusOutlined />}>
                          Add Report <DownOutlined />
                        </Button>
                      </Dropdown>,
                    ]
              }
              style={{ maxWidth: 1440, paddingBottom: 0 }}
            />
          )}
          <div style={{ margin: '0px 32px' }}>
            <Tabs
              onChange={(tab) => handleTabChange(tab)}
              activeKey={currentTab}
            >
              <TabPane tab='My Reports' key='my_reports' />
              {props.isAdmin && <TabPane tab='All Reports' key='all_reports' />}
              <TabPane tab='Report Templates' key='report_template' />
            </Tabs>
          </div>
          <Content
            style={{
              padding: !isReportLandingPage && '0px 32px 32px 32px',
              overflow: 'initial',
            }}
          >
            {(currentTab == 'my_reports' || currentTab == 'all_reports') && (
              <Table
                rowKey='_id'
                loading={loading || channelsLoading}
                columns={table_columns}
                dataSource={getReleventReports(cardSkillWithuser)}
                pagination={{ defaultPageSize: 20, showSizeChanger: true }}
              />
            )}

            {currentTab == 'report_template' && (
              <Card
                title='Choose a template below to get started'
                bodyStyle={
                  !props.skill
                    ? {
                        overflow: 'auto',
                        height: 'calc(100vh - 190px)',
                        justifyContent: 'flex-start',
                      }
                    : {}
                }
                // extra={<Button type="primary" icon={<CloseOutlined />} onClick={this.hideTemplates}>Cancel</Button>}
                loading={loading}
              >
                {/* <div style={{ marginBottom: '10px' }}>
                  {' '}
                  {props.showFilter &&
                    tagsFromServer.map((tag) => (
                      <CheckableTag
                        key={tag}
                        checked={selectedTags.indexOf(tag) > -1}
                        onChange={(checked) =>
                          this.handleCheckedtage(tag, checked)
                        }>
                        {tag}
                      </CheckableTag>
                    ))}
                </div> */}

                <Row
                  gutter={[16, 16]}
                  justify='flex-start'
                  // align='middle'
                  // className='cardSkillDisplay'
                >
                  {filteredSkills.map((item) => (
                    <Col span={8} key={item._id}>
                      <div
                        onClick={() => {
                          handleCreateClick(item);
                        }}
                      >
                        {item.isUpcoming ? (
                          <Card
                            cover={
                              <div
                                style={{
                                  height: '200px',
                                  // 'url("https://app-stage.troopr.io/logo/test1.png")'
                                  backgroundImage: `url(${item.logo})`,
                                  backgroundPosition: 'center',
                                  backgroundSize: '220px',
                                  backgroundRepeat: 'no-repeat',
                                  backgroundColor: '#001529',
                                }}
                              />
                            }
                          >
                            <Meta
                              avatar={
                                item.app === 'Jira' ? (
                                  <Avatar
                                    src='https://app.troopr.io/logo/jira.png'
                                    shape='square'
                                  />
                                ) : (
                                  <Avatar
                                    icon={<GithubOutlined />}
                                    style={{ color: 'black' }}
                                  />
                                )
                              }
                              title={item.name}
                            />
                          </Card>
                        ) : (
                          <Card
                            hoverable
                            cover={
                              <div
                                style={{
                                  height: '200px',
                                  // 'url("https://app-stage.troopr.io/logo/test1.png")'
                                  backgroundImage: `url(${item.logo})`,
                                  backgroundPosition: 'center',
                                  backgroundSize: '220px',
                                  backgroundRepeat: 'no-repeat',
                                  backgroundColor: '#001529',
                                }}
                              />
                            }
                          >
                            <Meta
                              avatar={
                                item.app === 'Jira' ? (
                                  <Avatar
                                    src='https://app.troopr.io/logo/jira.png'
                                    shape='square'
                                  />
                                ) : (
                                  <Avatar
                                    icon={<GithubOutlined />}
                                    style={{ color: 'black' }}
                                  />
                                )
                              }
                              title={item.name}
                            />
                          </Card>
                        )}
                      </div>
                    </Col>
                  ))}
                </Row>
              </Card>
            )}

            {showEditModal && (
              <EditSkill
                closeModal={() => setShowEditModal(false)}
                cardInfo={selectedCardSkill}
                visible={showEditModal}
              />
            )}
          </Content>
        </>
      )}
    </Layout>
  );
};

const mapStateToProps = (state) => ({
  currentSkill: state.skills.currentSkill,
  currentSkillUser: state.skills.currentSkillUser,
  cardSkills: state.cards.cardSkills,
  cardTemplates: state.cards.templateCards,
  channels: state.skills.channels,

  user_now: state.common_reducer.user,
  isAdmin: state.common_reducer.isAdmin,
  skills: state.skills.skills,
});

export default withRouter(
  connect(mapStateToProps, {
    getCardSkills,
    excecuteCardSkill,
    updateCardSkills,
    getCardTemplates,
    getChannelList,
    getSkillUser,
    getCurrentSkill,
    deleteCardSkill,
    cardInfo,
    saveCardSkills,
    resetStore,
  })(CardSkillList)
);
